export default "__VITE_ASSET__DfArouli__"